//
import OrdererPriorityModel from '@/models/Warehouse/WhOrdererPriority'
import ProductModel from '@/models/Warehouse/WhProductToSearch'
import ProviderModel from '@/models/Purchase/PchProvider'
import WarehouseModel from '@/models/Warehouse/WhWarehouse'
import UserModel from '@/models/General/GUser'

//
import ProductFilters from '@/views/Warehouse/WhProduct/list/filters'
import ProductHeaders from '@/views/Warehouse/WhProduct/picker/headers'
import { required } from '@/services/validations'
import DispatchRequestDetailHeaders from './headers'

//
export default ({
    g_branch_office_id,
    g_branch_office_selected_id,
    pch_provider_branch_offices,
    pch_provider_id,
    pch_provider_id_trigger,
    triggerWarehouse,
}) => [
    {
        name: 'g_supervisor_user_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemKey: 'id',
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Responsable',
            model: UserModel,
            noDataText: 'Sin empleados.',
            noObject: true,
            rules: [required],
        },
    },
    {
        name: 'wh_warehouse_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: 'name',
            itemValue: 'id',
            label: 'Bodega',
            model: WarehouseModel,
            noDataText: 'Sin bodegas.',
            noObject: true,
            paramFilter: {
                g_branch_office_id,
            },
            rules: [required],
        },
        trigger(ctx) {
            //
            const productsList = ctx.value.wh_selected_products || [],
                warehouse_id = ctx.value.wh_warehouse_id

            //
            productsList.forEach(product => {
                //
                product.stock = product.stocks.reduce((stock, branch) => {
                    return (
                        branch.wh_warehouses.reduce((stock, warehouse) => {
                            return warehouse.wh_warehouse_id === warehouse_id
                                ? stock + (warehouse.logical_stock || 0)
                                : stock
                        }, 0) + stock
                    )
                }, 0)
            })
        },
    },
    {
        name: 'pch_provider_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemKey: 'id',
            itemText: 'rut',
            itemValue: 'id',
            label: 'Rut',
            model: ProviderModel,
            noDataText: 'Sin proveedores.',
            noObject: true,
            rules: [required],
        },
        // trigger: pch_provider_id_trigger,
    },
    {
        name: 'pch_provider_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemKey: 'id',
            itemText: 'alias_name',
            itemValue: 'id',
            label: 'Proveedor',
            model: ProviderModel,
            noDataText: 'Sin proveedores.',
            noObject: true,
            rules: [required],
        },
        trigger: pch_provider_id_trigger,
    },
    {
        name: 'pch_provider_branch_offices_id',
        type: 'select',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            items: pch_provider_branch_offices,
            itemText: 'address',
            itemValue: 'id',
            label: 'Sucursal',
            noDataText: 'Sin sucursales.',
            noObject: true,
            //readonly: true,
            rules: [required],
        },
    },
    {
        name: 'wh_orderer_priority_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: 'priority',
            itemValue: 'id',
            label: 'Prioridad',
            model: OrdererPriorityModel,
            noDataText: 'Sin prioridades.',
            noObject: true,
            rules: [required],
        },
    },
    {
        name: 'wh_selected_products',
        type: 'table-field',
        flex: {
            'd-grid': true,
            'pt-0': true,
            xs12: true,
        },
        props: {
            checkable: true,
            class: 'v-card elevation-2 mb-4',
            headers: DispatchRequestDetailHeaders,
            noActions: true,
            noDataText: 'Sin productos.',
            noFilter: true,
            noExport: true,
            noHelper: true,
            noPagination: true,
            noSearch: true,
            label: 'Items',
            pickerProps: {
                attachParams: {
                    last_provider_code_provider_id: pch_provider_id,
                    stock_branch_office_id: g_branch_office_id,
                },
                filters: ProductFilters({ pch_provider_id, triggerWarehouse }),
                headers: JSON.parse(JSON.stringify(ProductHeaders)).filter((e,i)=> i!==5).map(e => {
                    if(e.value === 'stock_total') {
                        e.value = 'stock_branch_office'
                    }
                    return e
                }),
                noPagination: false,
                mapper: row => {
                    row['g_branch_office_id'] = g_branch_office_selected_id
                    row['provider_product_code'] = row.last_provider_code_provider || ''
                    row['quantity'] = 1
                    row['stock'] = row.stock || 0
                    row['wh_product_id'] = row.id
                    return row
                },
                mapperFilter: filters => ({
                    ...filters,
                    product_provider_code: pch_provider_id && filters.product_provider_code ? `${pch_provider_id},${filters.product_provider_code}` : undefined
                }),
                paramFilter: {
                    type: 'item',                    
                },
                rowsPerPage: 15,
                submitText: 'confirmar selección',
                service: ProductModel,
                title: 'Seleccionar producto',
            },
            showNativePagination: true,
            showPicker: true,
            toolbarTitle: 'Lista de productos incluidos en la orden',
            toolbarColor: 'primary',
            toolbarDark: true,
            toolbarDense: true,
            rules: [required],
        },
        trigger(ctx) {
            //
            const productsList = ctx.value.wh_selected_products || [],
                warehouse_id = ctx.value.wh_warehouse_id

            //
            productsList.forEach(product => {
                //
                product.stock = product.stocks.reduce((stock, branch) => {
                    return (
                        branch.wh_warehouses.reduce((stock, warehouse) => {
                            return warehouse.wh_warehouse_id === warehouse_id
                                ? stock + (warehouse.logical_stock || 0)
                                : stock
                        }, 0) + stock
                    )
                }, 0)
            })
        },
    },
    {
        name: 'comment',
        type: 'textarea',
        flex: {
            xs12: true,
        },
        props: {
            label: 'Comentario',
        },
    },
]
